export const onboardingFlowRoutes = {
  slides: "slides",
  userProfile: "user-profile",
  autoTranslationSetting: "auto-translation-setting",
  codeOfConduct: "code-of-conduct",
  groups: "groups",
  helpCategories: "help-categories",
  joinProjectConnection: "join-project-connection",
} as const;
